import React from "react"
import styled from "styled-components"

type ButtonTypes = "primary" | "secondary" | "tertiary"

type Props = {
  children: any
  onClick: () => void
  type?: ButtonTypes
}

type ButtonElementType = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  type: any
}

const ButtonElement = styled.button<ButtonElementType>`
  background-color: ${(prop): string =>
    prop.type === "primary"
      ? "var(--button-primary)"
      : "var(--button-secondary)"};
  padding: 22px 45px;
  border: 1.5px solid
    ${(prop): string =>
      prop.type === "primary"
        ? "var(--text-light)"
        : prop.type === "secondary"
        ? "var(--text-dark)"
        : "var(--text-light)"};
  cursor: pointer;
  outline: none;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 15px;
  font-family: "DIN";
  transition: all ease 300ms;
  color: ${(prop): string =>
    prop.type === "primary" || prop.type === "tertiary"
      ? "var(--text-light)"
      : "var(--text-dark)"};

  &:hover,
  &:focus,
  &:active {
    border: 1.5px solid
      ${(prop): string =>
        prop.type === "tertiary" ? "var(--text-light)" : "var(--text-dark)"};
    background-color: ${(prop): string =>
      prop.type === "primary"
        ? "var(--button-primary-hover)"
        : prop.type === "tertiary"
        ? "var(--text-light)"
        : "var(--button-secondary-hover)"};
    color: ${(prop): string =>
      prop.type === "primary" || prop.type === "secondary"
        ? "var(--text-light)"
        : "var(--text-dark)"};
  }
`

const Button: React.FC<Props> = ({
  children,
  onClick,
  type = "secondary",
  ...props
}: Props) => {
  return (
    <ButtonElement type={type} onClick={onClick} {...props}>
      {children}
    </ButtonElement>
  )
}

export default Button
